import { FC } from 'react';
import { UpdateReservings } from './UpdateReservings/UpdateReservings';

export const UpdateReservingsPage: FC = () => {
  return <UpdateReservings />;
};
